import Layout from '@/layouts/Layout'

const workbench = {
  path: '/workbench',
  component: Layout,
  name: 'workbench',
  meta: {
    title: '工作台-新',
    icon: 'dashboard',
  },
  children: [
    {
      path: '/workbench/dashboard/list',
      name: 'workbench_index',
      component: () => import('@/pages/workbench/dashboard/list'),
      meta: { title: '工作台', logEvent: '', keepAlive: false },
    },
    {
      path: '/workbench/dashboard/dataReport',
      name: 'workbench_data_board',
      component: () => import('@/pages/workbench/dataReport/list/index.vue'),
      meta: { title: '数据看板', logEvent: '' },
    },
    {
      path: '/workbench/rentOrder/list',
      name: 'workbench_rent_order',
      component: () => import('@/pages/orders/personalOrder/list/listTab.vue'),
      meta: { title: '个人租赁订单', logEvent: '' },
    },
    {
      path: '/workbench/rentOrder/detail',
      name: 'workbench_rent_order_detail',
      hidden: true,
      component: () => import('@/pages/orders/personalOrder/detail/index.vue'), // 和企业租赁子订单详情用同一个
      meta: {
        title: '租赁订单详情',
        logEvent: '',
        parent: {
          path: '/workbench/rentOrder/list',
          name: 'workbench_rent_order',
          title: '个人租赁订单',
        },
      },
    },
    {
      path: '/workbench/entOrder/list',
      name: 'workbench_ent_rent_order',
      component: () => import('@/pages/orders/enterpriseOrder/list/index.vue'),
      meta: { title: '企业租赁订单', logEvent: '' },
    },
    {
      path: '/workbench/entOrder/detail',
      name: 'workbench_ent_rent_order_main_detail',
      hidden: true,
      component: () => import('@/pages/orders/enterpriseOrder/detail/index'),
      meta: { title: '企业租赁主订单管理-详情', logEvent: '' },
    },
    {
      path: '/workbench/entOrder/detail/child',
      name: 'workbench_ent_rent_order_sub_detail',
      hidden: true,
      component: () =>
        import('@/pages/orders/enterpriseOrder/detail/child.vue'),
      meta: { title: '企业租赁订单管理-子订单详情', logEvent: '' },
    },
    {
      path: '/workbench/contractRelationRecord/list',
      name: 'workbench_contract_relation_record',
      component: () =>
        import('@/pages/orders/contractRelationRecord/list/index.vue'), // 和个人租赁订单详情用同一个
      meta: { title: '续约记录', logEvent: '' },
    },
    {
      path: '/workbench/batchCollectionRecordAdd',
      name: 'workbench_rent_order_to_receivable',
      component: () => import('@/pages/finance/AddCollection/index.vue'),
      meta: { title: '新增订单收款', logEvent: '' },
      hidden: true,
    },
    // 个人租赁子订单收款详情
    {
      path: '/workbench/order/collection/detail',
      name: 'workbench_rent_order_payment_detail',
      hidden: true,
      component: () => import('@/pages/orders/paymentDetail/index.vue'),
      meta: { title: '订单收款详情', logEvent: '' },
    },
    // 企业租赁子订单收款详情
    {
      path: '/workbench/order/sub/collection/detail',
      name: 'workbench_ent_rent_order_sub_payment_detail',
      hidden: true,
      component: () => import('@/pages/orders/paymentDetail'),
      meta: { title: '订单收款详情', logEvent: '' },
    },
  ],
}
export default workbench
